import { render } from "./OpenMembership.vue?vue&type=template&id=22cfda6e&scoped=true&ts=true&lang=pug"
import script from "./OpenMembership.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenMembership.vue?vue&type=script&lang=ts&setup=true"

import "./OpenMembership.vue?vue&type=style&index=0&id=22cfda6e&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cfda6e"]])

export default __exports__